


export const breakPoints = (ops) => {

    const device = [  // >= aplicar
        //1280, // desktop
        1024,   // laptop
        640,    // tablet
        0,      // mobile
    ]

    const width = window.innerWidth;

    for (const value of device) {
        if (width >= value) {
            return (ops[device.indexOf(value)])
        }
    }
}
